import { render, staticRenderFns } from "./MyContextMenu.vue?vue&type=template&id=f92b56da&scoped=true"
import script from "./MyContextMenu.vue?vue&type=script&lang=js"
export * from "./MyContextMenu.vue?vue&type=script&lang=js"
import style0 from "./MyContextMenu.vue?vue&type=style&index=0&id=f92b56da&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f92b56da",
  null
  
)

export default component.exports